var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./checkbox-group.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2a1e61e4\",\"hasScoped\":false}!../../../../vue-loader/lib/selector?type=template&index=0!./checkbox-group.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/iview/src/components/checkbox/checkbox-group.vue
// module id = 1314
// module chunks = 8